<template>
  <div class="blog-page">
    <AboutHeader />

    <div class="blog-body">
      <div class="blog-content">
        <h1>BLOG</h1>
        <div class="filter-tags">
          <div 
          v-for="tag in tags" 
            :key="tag"
            class="tag"
            :class="{'selected-tag': selectedTags.includes(tag)}"
            @click="selectTag(tag)">
            {{tag}}
          </div>
        </div>
        <div class="blog-cards">
          <BlogCard :blog="blog" v-for="blog in blogs.slice(0, 9)" :key="blog.id" />
        </div>
        <div class="wotive-banner">
          <div class="banner-holder">
            <img alt="Wotive community blog" src="../assets/wotive_blog.webp" />
          </div>
          <AboutWotive />
        </div>
        <div class="blog-cards">
          <BlogCard :blog="blog" v-for="blog in blogs.slice(9)" :key="blog.id" />
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/footer/Footer.vue';
import AboutHeader from '@/components/header/AboutHeader.vue';
import AboutWotive from '@/components/blog/AboutWotive.vue';
import BlogCard from '@/components/blog/BlogCard.vue';
import { formatDateTime } from '@/utils';
import { listBlogs } from '@/api/requests';
import { BLOG_TYPES } from '@/constants';

export default {
  name: 'Blog',

  metaInfo: {
    link: [
      {rel: 'canonical', href: 'https://wotive.com/blog/'}
    ],
  },

  data() {
    return {
      selectedTags: ['All types'],
      tags: BLOG_TYPES,
      blogs: [],
    };
  },

  components: {
    Footer,
    AboutHeader,
    AboutWotive,
    BlogCard,
  },

  mounted() {
    this.loadBlogs();
  },

  methods: {
    loadBlogs() {
      const payload = {
        'types': this.selectedTags
      };
      listBlogs(payload).then(response => {
        this.blogs = response.data;
      }).catch(() => {
        // TODO errors
      });
    },

    selectTag(tag) {
      if (this.selectedTags.includes(tag)) {
        this.selectedTags = [];
      } else {
        this.selectedTags = [tag];
      }

      if (this.selectedTags.length == 0) {
        this.selectedTags = ['All types'];
      }

      this.loadBlogs();
    },

    formatDate(date) {
      return formatDateTime(date);
    },
  },

  computed: {
    pageTitle() {
      if (this.type === 'about') {
        return 'about POLICY';
      } else {
        return 'TERMS OF SERVICE';
      }
    },

    url() {
      let url = window.location.origin;
      if (url === "http://localhost:8080") {
        url = "http://localhost:3000";
      }
      return url;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/css/variables";
.blog-body {
  margin-bottom: 40px;
}

.blog-page {
  background: #F4F7FA;

  .blog-content {
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    max-width: 1222px;
    margin: auto;
  }
  
  h1 {
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 10px;
  }

  .filter-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: center;
    align-items: center;
    
    .tag {
      border-radius: 100px;
      background: $sec7;
      padding: 6px 12px;
      color: $sec2;
      cursor: pointer;
      font-size: $font-size-small;
      text-transform: uppercase;
    }
    .tag:hover {
      background: $sec6;
    }

    .selected-tag {
      background: $blue;
      color: #FFF;
    }
    .selected-tag:hover {
      background: $blue;
    }
  }

  .blog-cards {
    display: grid;
    column-gap: 40px;
    row-gap: 40px;
    margin-top: 40px;
    margin-bottom: 40px;
    grid-template-columns: repeat(1, 1fr);
  }
}

.wotive-banner {
  display: none;
  .banner-holder {
    margin-bottom: 20px;
    width: 100%;
  }
  img {
    flex: 1;
    object-fit: cover;
    width: 100%;
  }
  .blog-cta {
    margin-left: 20px;
    min-width: 180px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

@media all and (min-width: 750px) {
  .blog-page .blog-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media all and (min-width: 1200px) {
  .blog-page .blog-cards {
    grid-template-columns: repeat(3, 1fr);
  }

  .wotive-banner {
    display: flex;
    .banner-holder {
      margin-bottom: 0;
    }
  }
}

</style>